@use './variables' as *;
@use '../../styles/abstracts/break-points' as *;

:host {
  display: $info-box-display;
}

.info-box {
  display: flex;
  position: relative;
  align-items: start;
  width: $info-box-width;
  max-width: $info-box-width;
  padding-top: $info-box-padding-top;
  padding-right: $info-box-padding-right;
  padding-bottom: $info-box-padding-bottom;
  padding-left: $info-box-padding-left;
  border-width: $info-box-border-width;
  border-style: $info-box-border-style;
  border-color: $info-box-border-color;
  border-radius: $info-box-border-radius;
  font-family: $info-box-font-family;
  background-color: $info-box-background-color;
  box-shadow: $info-box-shadow;
  justify-items: stretch;

  &.hidden {
    display: none;
  }

  &-heading {
    display: flex;
    position: relative;
    align-items: $info-box-heading-align-items;
    justify-content: $info-box-heading-justify-content;
    min-height: $info-box-heading-height;
    color: $info-box-heading-color;
    font-weight: $info-box-heading-font-weight;
    font-size: $info-box-heading-font-size;
    line-height: $info-box-heading-line-height;
    font-family: $info-box-heading-font-family;
  }

  &-text {
    color: $info-box-color-text;
  }

  &-close {
    display: inline-flex;
    cursor: pointer;
  }

  &-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    width: 100%;
    color: $info-box-content-color;
  }

  &-markdown {
    color: $info-box-content-color;
    font-family: $info-box-content-font-family;
    font-size: $info-box-content-font-size;
    line-height: $info-box-content-line-height;
    font-weight: $info-box-content-font-weight;
  }

  &-modal .info-box {
    box-shadow: none;
    padding: 0;
    --air-info-box-background-color: #{$modal-info-box-background-color};

    & p:first-of-type {
      margin-top: 0;
    }
  }
}
